import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ProductElementEpdChange =
  ProjectChangeMap[ProjectChangeType.ProductElementEpd];

/**
 * Switch EPD product linkage: {@link IProductElement.product_id} and {@link IProductElement.generic_product_id}.
 *
 * @param element - Current element state
 * @param change - Product / generic product ids
 * @returns Partial element or undefined when not a product element
 */
export const productElementEpdToChange = (
  element: OneOfElements,
  change: ProductElementEpdChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.productElement(element)) return undefined;
  if (
    element.product_id === change.productId &&
    element.generic_product_id === change.genericProductId
  ) {
    return undefined;
  }

  return {
    generic_product_id: change.genericProductId,
    product_id: change.productId,
  };
};
